import { useMemo } from 'react'
import { useSearch } from '@tanstack/react-router'

import {
  SHIPMENT_STAGES,
  useDefaultOwnerSettled,
  useShipmentListFilters,
  useShipmentListPage,
} from '#/entities/shipment'
import type {
  ShipmentListFilters,
  ShipmentListFiltersState,
  UseShipmentListPageResult,
} from '#/entities/shipment'
import type { ShipmentStatus } from '#/shared/api/generated/shipment/models'
import { leadsStatusForTab } from './tabs'

export interface UseLeadsPageResult extends UseShipmentListPageResult {
  filters: ShipmentListFiltersState
  /** Active status-tab filter; also narrows owner counts. */
  status: ShipmentStatus
}

export function useLeadsPage(): UseLeadsPageResult {
  const raw: Record<string, unknown> = useSearch({ strict: false })
  const tabParam = typeof raw['status'] === 'string' ? raw['status'] : undefined
  const status = leadsStatusForTab(tabParam)
  const filters = useShipmentListFilters(SHIPMENT_STAGES.LEAD)
  const apiFilters = useMemo<ShipmentListFilters>(
    () => ({ ...filters.apiFilters, status }),
    [filters.apiFilters, status],
  )
  const enabled = useDefaultOwnerSettled(filters.userId)
  const base = useShipmentListPage(
    SHIPMENT_STAGES.LEAD,
    undefined,
    apiFilters,
    { enabled },
  )
  return { ...base, filters, status }
}
